import Link from 'next/link';
import React, { useState } from 'react'
import { User } from '../../../models';
import ProBadgeSvg from '../../svgs/ProBadgeSvg';


interface Props {
  user: User | null
}
const ProInsignia: React.FC<Props> = ({ user }) => {
  if (!user) return null;
  if (user.membership?.type !== "paid") return null;
  return (
    <Link href="/membresia" >
      <a target="_blank" className="hover:opacity-75"><ProBadgeSvg className="w-6 h-4" /></a>
    </Link>
  )
}


export default ProInsignia;